import { Link } from "react-router-dom";
import { Trophy } from "lucide-react";

export default function LegalLayout({ title, effectiveDate, children }) {
  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white">
      {/* Nav */}
      <header className="border-b border-[#27272A] py-4 sticky top-0 bg-[#0A0A0A]/95 backdrop-blur z-10">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2" data-testid="legal-back-home">
            <div className="w-6 h-6 bg-[#178AE5] flex items-center justify-center rounded-sm">
              <Trophy className="w-4 h-4 text-white" />
            </div>
            <span className="font-logo text-sm tracking-wide whitespace-nowrap">
              SALES<span className="text-[#178AE5]">ARENA HQ</span>
            </span>
          </Link>
          <div className="flex items-center gap-4 sm:gap-6 text-xs sm:text-sm text-[#A1A1AA] flex-wrap justify-end">
            <Link to="/terms" className="hover:text-white transition-colors" data-testid="legal-nav-terms">Terms</Link>
            <Link to="/privacy" className="hover:text-white transition-colors" data-testid="legal-nav-privacy">Privacy</Link>
            <Link to="/refund-policy" className="hover:text-white transition-colors" data-testid="legal-nav-refund">Refunds</Link>
            <Link to="/eula" className="hover:text-white transition-colors" data-testid="legal-nav-eula">EULA</Link>
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-6 lg:px-8 py-16">
        <div className="mb-10 pb-6 border-b border-[#27272A]">
          <h1
            className="font-display text-4xl sm:text-5xl uppercase tracking-tight leading-none mb-3"
            data-testid="legal-title"
          >
            {title}
          </h1>
          <p className="text-sm text-[#A1A1AA] uppercase tracking-widest">
            Effective {effectiveDate}
          </p>
        </div>
        <article className="prose prose-invert max-w-none legal-content text-[15px] leading-relaxed text-[#D4D4D8]">
          {children}
        </article>
      </main>

      {/* Footer */}
      <footer className="border-t border-[#27272A] py-8 mt-16">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-[#A1A1AA]">
          <p>© 2026 SALESARENA HQ LLC. Built for closers.</p>
          <p>Questions? <a href="mailto:support@salesarenahq.com" className="text-[#178AE5] hover:underline">support@salesarenahq.com</a></p>
        </div>
      </footer>

      {/* Section styles */}
      <style>{`
        .legal-content h2 {
          font-family: Impact, Haettenschweiler, "Arial Narrow Bold", sans-serif;
          font-size: 22px;
          text-transform: uppercase;
          letter-spacing: -0.01em;
          color: #FFFFFF;
          margin: 40px 0 12px;
          padding-top: 8px;
          border-top: 1px solid #27272A;
        }
        .legal-content h2:first-of-type { border-top: 0; padding-top: 0; }
        .legal-content h3 {
          font-size: 15px;
          font-weight: 600;
          color: #FFFFFF;
          margin: 20px 0 8px;
          text-transform: uppercase;
          letter-spacing: 0.08em;
          font-size: 12px;
        }
        .legal-content p { margin: 0 0 12px; }
        .legal-content ul, .legal-content ol { margin: 0 0 16px 20px; }
        .legal-content li { margin-bottom: 6px; }
        .legal-content a { color: #178AE5; text-decoration: underline; }
        .legal-content strong { color: #FFFFFF; }
      `}</style>
    </div>
  );
}
